import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=2b8f6529&"
import script from "./Facebook.vue?vue&type=script&lang=js&"
export * from "./Facebook.vue?vue&type=script&lang=js&"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=2b8f6529&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports